"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var rlp_1 = require("rlp");

var address_1 = require("../address");

var account_1 = tslib_1.__importDefault(require("../eth-lib/account"));

var bytes_1 = tslib_1.__importDefault(require("../eth-lib/bytes"));

var nat_1 = tslib_1.__importDefault(require("../eth-lib/nat"));

var rlp_2 = tslib_1.__importDefault(require("../eth-lib/rlp"));

var formatters_1 = require("../formatters");

var utils_1 = require("../utils");

function signTransaction(_x, _x2, _x3) {
  return _signTransaction.apply(this, arguments);
}

function _signTransaction() {
  _signTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tx, privateKey, eth) {
    var promises, _yield$Promise$all, _yield$Promise$all2, chainId, gasPrice, nonce;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (tx.gas) {
              _context.next = 2;
              break;
            }

            throw new Error('gas is missing or 0');

          case 2:
            if (!(tx.nonce !== undefined && tx.chainId !== undefined && tx.gasPrice !== undefined)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", sign(tx, privateKey));

          case 4:
            // Otherwise, get the missing info from the Ethereum Node
            promises = [isNot(tx.chainId) ? eth.getId() : Promise.resolve(tx.chainId), isNot(tx.gasPrice) ? eth.getGasPrice() : Promise.resolve(tx.gasPrice), isNot(tx.nonce) ? eth.getTransactionCount(address_1.Address.fromString(account_1.default.fromPrivate(privateKey).address)) : Promise.resolve(tx.nonce)];
            _context.next = 7;
            return Promise.all(promises);

          case 7:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
            chainId = _yield$Promise$all2[0];
            gasPrice = _yield$Promise$all2[1];
            nonce = _yield$Promise$all2[2];

            if (!(isNot(chainId) || isNot(gasPrice) || isNot(nonce))) {
              _context.next = 14;
              break;
            }

            throw new Error('One of the values chainId, gasPrice, or nonce could not be fetched');

          case 14:
            return _context.abrupt("return", sign(_objectSpread({}, tx, {
              chainId: chainId,
              gasPrice: gasPrice,
              nonce: nonce
            }), privateKey));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _signTransaction.apply(this, arguments);
}

exports.signTransaction = signTransaction;

function recoverTransaction(rawTx) {
  var values = rlp_2.default.decode(rawTx);
  var signature = account_1.default.encodeSignature(values.slice(6, 9));
  var recovery = bytes_1.default.toNumber(values[6]);
  var extraData = recovery < 35 ? [] : [bytes_1.default.fromNumber(recovery - 35 >> 1), '0x', '0x'];
  var signingData = values.slice(0, 6).concat(extraData);
  var signingDataHex = rlp_2.default.encode(signingData);
  return account_1.default.recover(utils_1.sha3(signingDataHex), signature);
}

exports.recoverTransaction = recoverTransaction;

function sign(tx, privateKey) {
  if (tx.nonce < 0 || tx.gas < 0 || tx.gasPrice < 0 || tx.chainId < 0) {
    throw new Error('gas, gasPrice, nonce or chainId is lower than 0');
  }

  var chainId = utils_1.numberToHex(tx.chainId);
  var toEncode = [bytes_1.default.fromNat(utils_1.numberToHex(tx.nonce)), bytes_1.default.fromNat(utils_1.numberToHex(tx.gasPrice)), bytes_1.default.fromNat(utils_1.numberToHex(tx.gas)), tx.to ? formatters_1.inputAddressFormatter(tx.to) : '0x', bytes_1.default.fromNat(tx.value ? utils_1.numberToHex(tx.value) : '0x'), tx.data ? utils_1.bufferToHex(tx.data) : '0x', bytes_1.default.fromNat(chainId || '0x1'), '0x', '0x'];
  var rlpEncoded = rlp_1.encode(toEncode);
  var messageHash = utils_1.sha3(rlpEncoded);
  var signature = account_1.default.makeSigner(nat_1.default.toNumber(chainId || '0x1') * 2 + 35)(messageHash, privateKey);
  var rawTx = [].concat(_toConsumableArray(rlp_1.decode(rlpEncoded).slice(0, 6)), _toConsumableArray(account_1.default.decodeSignature(signature)));
  rawTx[6] = utils_1.makeHexEven(utils_1.trimHexLeadingZero(rawTx[6]));
  rawTx[7] = utils_1.makeHexEven(utils_1.trimHexLeadingZero(rawTx[7]));
  rawTx[8] = utils_1.makeHexEven(utils_1.trimHexLeadingZero(rawTx[8]));
  var rawTransaction = rlp_1.encode(rawTx);
  var values = rlp_1.decode(rawTransaction);
  return {
    messageHash: messageHash,
    v: utils_1.trimHexLeadingZero(utils_1.bufferToHex(values[6])),
    r: utils_1.trimHexLeadingZero(utils_1.bufferToHex(values[7])),
    s: utils_1.trimHexLeadingZero(utils_1.bufferToHex(values[8])),
    rawTransaction: utils_1.bufferToHex(rawTransaction)
  };
}

exports.sign = sign;

function isNot(value) {
  return value === undefined || value === null;
}